import { Component, inject } from '@angular/core';
import { GlossaryService } from '../../services/glossary.service';
import type { GlossaryContributors } from '../../interfaces/glossaryInterface';

@Component({
    selector: 'app-glossary-contributors',
    imports: [],
    templateUrl: './glossary-contributors.component.html',
    styleUrl: './glossary-contributors.component.scss'
})
export class GlossaryContributorsComponent {
  private readonly glossaryService = inject(GlossaryService);
  protected contributors: GlossaryContributors = this.glossaryService.getContributors();
}
